import { render } from "./ReservationConfirmed.vue?vue&type=template&id=cd4d2334"
import script from "./ReservationConfirmed.vue?vue&type=script&lang=js"
export * from "./ReservationConfirmed.vue?vue&type=script&lang=js"

import exportComponent from "/usr/share/nginx/production/driver/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__